const actionTypes = {
	LOGIN_USER: "LOGIN_USER",
	LOGOUT_USER: "LOGOUT_USER",
	UPDATEFAVORITES: "UPDATEFAVORITES",
	CHANGELINK: "CHANGELINK",
	CLOUDSTORAGECONFIGURATION:"CLOUDSTORAGECONFIGURATION"
}
export default actionTypes;